import React from 'react';

import styled from 'styled-components';

export default function Benefits() {
  return (
    <StyledBenefits>
      <StyledBenefitsContentsContainer>
        <StyledTag>BENEFITS AND WELLNESS</StyledTag>
        <StyledBenefitsList>
          {BENEFITS_IMAGES.map(({ id, alt, src }) => (
            <StyledBenefitItem key={id}>
              <StyledBenefitImage alt={alt} src={src} />
            </StyledBenefitItem>
          ))}
        </StyledBenefitsList>
        <StyledMobileBenefitsList>
          {BENEFITS_MOBILE_IMAGES.map(({ id, alt, src, text }) => (
            <StyledMobileBenefitItem key={id}>
              <StyledMobileBenefitImage alt={alt} src={src} />
              <StyledBenefitText>{text}</StyledBenefitText>
            </StyledMobileBenefitItem>
          ))}
        </StyledMobileBenefitsList>
      </StyledBenefitsContentsContainer>
    </StyledBenefits>
  );
}

const StyledBenefits = styled.article`
  padding: 200px 0 200px;

  ${({ theme }) => theme.mobile`
  padding: 96px 0 ;
  `}
`;

const StyledBenefitsContentsContainer = styled.div`
  margin: 0 auto;
  padding: 0 30px;
  max-width: 1340px;
`;

const StyledTag = styled.h2`
  color: ${({ theme }) => theme.colors.green};
  margin-bottom: 18px;
`;

const StyledBenefitsList = styled.ul`
  ${({ theme }) => theme.flex('row', 'space-between')};
  flex-wrap: wrap;

  li:nth-child(n + 5):nth-child(-n + 8) {
    margin-bottom: 0;
  }

  ${({ theme }) => theme.mobile`
    display: none;
  `}
`;

const StyledMobileBenefitsList = styled.ul`
  display: none;

  ${({ theme }) => theme.mobile`
    ${({ theme }) => theme.flex('row', 'space-between', 'stretch')};
  flex-wrap: wrap;
  `}
`;

const StyledBenefitItem = styled.li`
  width: 23.4%;
  margin-bottom: 28px;
`;

const StyledMobileBenefitItem = styled.li`
  width: 48%;
  margin-bottom: 28px;
  ${({ theme: { flex } }) => flex('column', 'flex-start')};
  padding: 28px;
  border: 1px solid ${({ theme: { colors } }) => colors.grey4};
`;

const StyledBenefitImage = styled.img`
  width: 100%;
`;

const StyledMobileBenefitImage = styled.img`
  width: 15.3vw;
`;

const StyledBenefitText = styled.p`
  font-size: 14px;
  max-width: 190px;
`;

const BENEFITS_IMAGES = [
  {
    id: 1,
    alt: 'meal image',
    src: 'images/About/benefits/meal/meal@3x.png',
  },
  {
    id: 2,
    alt: 'education image',
    src: 'images/About/benefits/education/education@3x.png',
  },
  {
    id: 3,
    alt: 'location image',
    src: 'images/About/benefits/location/location@3x.png',
  },
  {
    id: 4,
    alt: 'working image',
    src: 'images/About/benefits/working/working@3x.png',
  },
  {
    id: 5,
    alt: 'vacation image',
    src: 'images/About/benefits/vacation/vacation@3x.png',
  },
  {
    id: 6,
    alt: 'night_working image',
    src: 'images/About/benefits/night_working/night_working@3x.png',
  },
  {
    id: 7,
    alt: 'home_working image',
    src: 'images/About/benefits/home_working/home_working@3x.png',
  },
  {
    id: 8,
    alt: 'professional image',
    src: 'images/About/benefits/professional/professional@3x.png',
  },
];

const BENEFITS_MOBILE_IMAGES = [
  {
    id: 1,
    alt: 'meal mobile images',
    src: 'images/About/benefits/meal/meal_mobile2@3x.png',

    text: '점심 / 저녁(부득이한 야근시) 식대를 지원합니다.',
  },
  {
    id: 2,
    alt: 'education mobile images',
    src: 'images/About/benefits/education/education_mobile2@3x.png',

    text: '개인의 성장을 위핸 직무 교육비, 도서비를 지원합니다.',
  },
  {
    id: 3,
    alt: 'location mobile images',
    src: 'images/About/benefits/location/location_mobile2@3x.png',

    text: '대한민국 금융의 중심지 여의도에 위치한 사무실',
  },
  {
    id: 4,
    alt: 'working mobile images',
    src: 'images/About/benefits/working/working_mobile2@3x.png',

    text: '주 5일 유연 근무 (8-11시 출근 / 17-20시 퇴근)',
  },
  {
    id: 5,
    alt: 'vacation mobile images',
    src: 'images/About/benefits/vacation/vacation_mobile2@3x.png',

    text: '자율 휴가제(연차 / 반차) 사유는 묻지 않습니다.',
  },
  {
    id: 6,
    alt: 'night_working mobile images',
    src: 'images/About/benefits/night_working/night_working_mobile2@3x.png',

    text: '야근을 강요하지 않고 회식도 강요하지 않습니다.',
  },
  {
    id: 7,
    alt: 'home_working mobile images',
    src: 'images/About/benefits/home_working/home_working_mobile2@3x.png',

    text: '원격(재택) 근무로 출퇴근 시간의 제약 없이 효율적으로 일할 수 있습니다.',
  },
  {
    id: 8,
    alt: 'professional mobile images',
    src: 'images/About/benefits/professional/professional_mobile2@3x.png',

    text: '각 분야의 전문가들이 전문분야를 공유하는 세미나를 진행합니다.',
  },
];
